import { render } from "./CustomCalendar.vue?vue&type=template&id=3e886e96"
import script from "./CustomCalendar.vue?vue&type=script&lang=js"
export * from "./CustomCalendar.vue?vue&type=script&lang=js"

import "./CustomCalendar.vue?vue&type=style&index=0&id=3e886e96&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\italia-finanza-datarete\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__